/**
 * @file  functions/rates.ts
 * @description  function library for the rates api
 *
 * @author ogarcia (ozkary)
 *
 */
import { Document as RatesDocument } from './rates.model';
import * as api from '../index';

/**
 * gets the product configuration for the site
 * @param type the rates type to fetch ppm/vsc
 */
export const getRates = async (type = 'ppm'): Promise<RatesDocument> => {
  const { get } = api;
  const result: RatesDocument = await get<RatesDocument>(`rates/${type}`);
  return result;
};

/**
 * sets the product configuration for the site
 * @param data the rates document
 */
export const setRates = async (data: RatesDocument): Promise<RatesDocument> => {
  const { post } = api;
  const result: RatesDocument = await post<RatesDocument>('rates', data);
  return result;
};
